"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _facebookSearchDatasource = _interopRequireDefault(require("./datasources/facebook-search-datasource"));

var _facebookTimelineDatasource = _interopRequireDefault(require("./datasources/facebook-timeline-datasource"));

var _singleplatformDatasource = _interopRequireDefault(require("./datasources/singleplatform-datasource"));

var _facebookPhotosDatasource = _interopRequireDefault(require("./datasources/facebook-photos-datasource"));

var _facebookVideosDatasource = _interopRequireDefault(require("./datasources/facebook-videos-datasource"));

var _facebookAboutDatasource = _interopRequireDefault(require("./datasources/facebook-about-datasource"));

var _yelpBusinessDatasource = _interopRequireDefault(require("./datasources/yelp-business-datasource"));

var DataSourceHelper =
/*#__PURE__*/
function () {
  function DataSourceHelper() {
    (0, _classCallCheck2["default"])(this, DataSourceHelper);
  }

  (0, _createClass2["default"])(DataSourceHelper, null, [{
    key: "getDataSource",
    value: function getDataSource(type) {
      switch (type.toLowerCase()) {
        case 'facebooksearch':
          return _facebookSearchDatasource["default"];

        case 'facebook':
          return _facebookTimelineDatasource["default"];

        case 'singleplatform':
          return _singleplatformDatasource["default"];

        case 'facebookphotos':
          return _facebookPhotosDatasource["default"];

        case 'facebookvideos':
          return _facebookVideosDatasource["default"];

        case 'facebookabout':
          return _facebookAboutDatasource["default"];

        case 'yelpbusiness':
          return _yelpBusinessDatasource["default"];
      }

      throw new Error('Missing datasource');
    }
  }]);
  return DataSourceHelper;
}();

var _default = DataSourceHelper;
exports["default"] = _default;